import React, { useState } from "react";
import "./FAQSection.css";

const FAQS = [
  {
    q: "How often should I visit the dentist?",
    a: "We recommend visiting every 6 months for a routine check-up and cleaning to maintain optimal oral health."
  },
  {
    q: "Do dental treatments hurt?",
    a: "We use modern pain-free techniques and local anesthesia to ensure your comfort throughout the procedure."
  },
  {
    q: "Are aligners better than braces?",
    a: "Aligners are discreet and removable. Braces may be preferred for complex corrections. We help choose what’s best for you."
  },
  {
    q: "Do teeth whitening damage enamel?",
    a: "Professionally supervised whitening is completely safe and does not damage tooth enamel."
  }
];

export default function FAQSection() {
  const [open, setOpen] = useState(null);

  const toggle = (i) => {
    setOpen(open === i ? null : i);
  };

  return (
    <section className="faq">
    <div className="faq-container">
      <h2 className="faq-heading">FAQs </h2>

      {FAQS.map((item, i) => (
        <div key={i} className="faq-row" onClick={() => toggle(i)}>
          <div className="faq-left">
            <span className="faq-plus">{open === i ? "−" : "+"}</span>
            <span className="faq-question">{item.q}</span>
          </div>

          <div className={`faq-answer ${open === i ? "open" : ""}`}>
            {item.a}
          </div>
        </div>
      ))}
    </div>
    </section>
  );
}
